import { getToken } from './auth'

const BASE_URL = process.env.VUE_APP_BASE_API || '/prod-api'

function buildUrl(url, params) {
  const query = new URLSearchParams()
  Object.keys(params || {}).forEach(key => {
    const value = params[key]
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, value)
    }
  })
  const queryString = query.toString()
  return `${BASE_URL}${url}${queryString ? `?${queryString}` : ''}`
}

export default async function request(options) {
  const headers = { Accept: 'application/json', ...(options.headers || {}) }
  const isToken = headers.isToken !== false
  delete headers.isToken

  const token = getToken()
  if (token && isToken) headers.Authorization = `Bearer ${token}`

  let requestBody
  if (options.data instanceof FormData) {
    requestBody = options.data
  } else if (options.data !== undefined) {
    headers['Content-Type'] = headers['Content-Type'] || 'application/json;charset=utf-8'
    requestBody = JSON.stringify(options.data)
  }

  const response = await window.fetch(buildUrl(options.url, options.params), {
    method: (options.method || 'get').toUpperCase(),
    headers,
    body: requestBody,
    cache: options.cache || 'no-store'
  })

  if (options.responseType === 'blob') {
    if (!response.ok) throw new Error('文件下载失败，请稍后重试')
    return response.blob()
  }

  let responseBody
  try {
    responseBody = await response.json()
  } catch (error) {
    throw new Error(response.ok ? '服务响应异常，请稍后重试' : '登录服务暂不可用，请稍后重试')
  }

  if (!responseBody || !response.ok || Number(responseBody.code) !== 200) {
    throw new Error((responseBody && responseBody.msg) || '请求失败，请稍后重试')
  }
  return responseBody
}
